"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.defaultErrors = void 0;
const BackendUnavailableError_1 = require("./BackendUnavailableError");
const InputValidationError_1 = require("./InputValidationError");
const InternalServerError_1 = require("./InternalServerError");
const UnauthorizedError_1 = require("./UnauthorizedError");
exports.defaultErrors = [
    InputValidationError_1.InputValidationError,
    UnauthorizedError_1.UnauthorizedError,
    InternalServerError_1.InternalServerError,
    BackendUnavailableError_1.BackendUnavailableError,
];
